// TODO: duplicated on graphql/src/authentication/helpers/cookies.js... move to @clubmed/utils
export const ACCESS_TOKEN = 'CM_TOKEN';
export const USER_INFO = 'cm_userinfo';
export const SELLER_ACCESS_TOKEN = 'CM_SELLER_TOKEN';
export const SELLER_LOGGED = 'SELLER_LOGGED';
export const SELLER_INFO = 'cm_seller_info';
